/* ==============================================================================================
 * TABLES
 * ============================================================================================== */

var Sushi, CGS, Icons, $ = window.jQuery;

(function (Sushi, CGS) {
	"use strict";

	CGS.table = function (tableElement, options) {
		if (!tableElement || !options || !options.ajax || !options.columns || !options.columnDefs) {
			return;
		}

		var dataTable = null;
		var columns = options.columns;
		var tableHead = tableElement.querySelector("thead");
		var tableHeadRow = tableHead.querySelector("tr");

		tableElement.classList.add("c-table");
		tableHead.classList.add("c-table__head");
		tableHeadRow.classList.add("c-table__row");

		var setUpHeadClasses = function () {
			var cells = tableHeadRow.querySelectorAll("th");

			for (var i = 0; i < columns.length; i++) {
				$(cells[i]).addClass("c-table__cell");

				if (columns[i].searchable) {
					$(cells[i]).addClass("c-table__cell--searchable");
				}

				if (columns[i].orderable !== false) {
					$(cells[i]).addClass("c-table__cell--sortable");
				}
			}
		};

		var createSearchRow = function () {
			var searchRow = tableHeadRow.cloneNode(true);

			searchRow.classList.add("c-table__searchRow");
			tableHead.appendChild(searchRow);

			var cells = searchRow.querySelectorAll("th");

			Sushi.Dom.forEach(cells, function (cell) {
				cell.innerHTML = "";

				if (cell.classList.contains("c-table__cell--searchable")) {
					cell.innerHTML = ""
						+ "<span class='c-table__searchInput'>"
						+ "<input type='text' placeholder='Search by keyword'>"
						+ "</span>"
						+ "<span class='c-table__searchButton'></span>";

					var input = cell.querySelector(".c-table__searchInput");
					var trigger = cell.querySelector(".c-table__searchButton");
					var isOpen = false;

					if (!input || !trigger) {
						return;
					}

					Sushi.Events(input).on("click", function (event) {
						event.stopPropagation();
					});

					Sushi.Events(trigger).on("click", toggle);
				}

				/**
				 * Toggle search input
				 *
				 * @return {void}
				 */
				function toggle() {
					isOpen ? close() : open();
					isOpen = !isOpen;
				}

				/**
				 * Open search input
				 *
				 * @return {void}
				 */
				function open() {
					cell.classList.add("is-active");
					setTimeout(function () {
						input.querySelector("input").focus();
					}, 100);
				}

				/**
				 * Close search input
				 *
				 * @return {void}
				 */
				function close() {
					cell.classList.remove("is-active");
				}
			});
		};

		var setUpTableSearch = function () {
			var searchRowCells = tableElement.querySelectorAll(".c-table__searchRow th");

			Sushi.Dom.forEach(searchRowCells, function (cell, i) {
				var input = cell.querySelector("input");

				if (!input) {
					return;
				}

				Sushi.Events(input).on("keyup change", function () {
					if (dataTable.column(i).search() !== this.value) {
						dataTable
							.column(i)
							.search(this.value)
							.draw();
					}
				});
			});
		};

		var setUpTableTooltips = function () {
			var dtFileChecks = $("[data-tooltip=dt-file-check]");

			if (dtFileChecks.length) {
				dtFileChecks.each(function (i, el) {
					if (!$(el).hasClass("tooltipstered")) {
						$(el).tooltipster({
							theme: "tooltipster--small",
							maxWidth: 320,
						});
					}
				});
			}

			var dtFooterButtons = $("[data-tooltip=dt-footer-button]");

			if (dtFooterButtons.length) {
				dtFooterButtons.each(function (i, el) {
					if (!$(el).hasClass("tooltipstered")) {
						$(el).tooltipster({
							theme: "tooltipster--small",
							maxWidth: 320,
						});
					}
				});
			}
		};

		setUpHeadClasses();
		createSearchRow();
		setUpTableSearch();

		Object.assign($.fn.dataTable.ext.classes, {
			sPageButton: "c-tableFooter__paginationButton",
			sPageButtonActive: "c-tableFooter__paginationButton--active",
			sPageButtonDisabled: "c-tableFooter__paginationButton--disabled",
			sRowEmpty: "dataTables_empty c-table__cell",
			sPaging: "c-tableFooter__pagination _1/3@laptop _phxs@laptop paging_",
			sInfo: "c-tableFooter__info _1/3@laptop",
		});

		var dataTableOptions = {
			ajax: options.ajax,
			dom: options.dom ? options.dom : "<'top'>rt<'c-tableFooter'pi<'c-table__export'B>>",
			pageLength: options.pageLength !== undefined ? options.pageLength : 20,
			orderCellsTop: options.orderCellsTop !== undefined ? options.scrollY : true,
			scrollY: options.scrollY !== undefined ? options.scrollY : "100%",
			scrollX: options.scrollX !== undefined ? options.scrollX : true,
			buttons: options.buttons !== undefined ? options.buttons : [
				{
					text: Icons.fileCheck(),
					extend: "copy",
					attr: {
						"data-tooltip": "dt-footer-button",
						title: "Copy table data to the clipboard",
					},
				},
				{
					text: Icons.filePDF(),
					extend: "pdf",
					attr: {
						"data-tooltip": "dt-footer-button",
						title: "Export table data as PDF",
					},
				},
				{
					text: Icons.fileCSV(),
					extend: "csv",
					attr: {
						"data-tooltip": "dt-footer-button",
						title: "Export table data as CSV",
					},
				},
				{
					text: Icons.fileXLS(),
					extend: "excel",
					attr: {
						"data-tooltip": "dt-footer-button",
						title: "Export table data as XSL",
					},
				},
			],
			columnDefs: options.columnDefs,
			columns: options.columns,
			order: options.order !== undefined ? options.order : [],
			paging: options.paging !== undefined ? options.paging : true,
			destroy: true,
			language: {
				zeroRecords: "<span>No matching records found</span>",
			},
			rowCallback: options.rowCallback !== undefined ? options.rowCallback : null,
			autowidth: false,
			createdRow: function (row) {
				row.classList.add("c-table__row");

				if (options.createdRow) {
					options.createdRow(row);
				}
			},
			initComplete: function (settings, json) {
				setUpTableTooltips();

				Sushi.Events(tableElement).trigger("initComplete");

				if (options.initComplete) {
					options.initComplete(settings, json);
				}

				settings.nTableWrapper.setAttribute("data-plugin", "FadeScrollable");
				settings.nScrollBody.setAttribute("data-fade-scrollable-track", "");
				settings.nTable.setAttribute("data-fade-scrollable-content", "");

				var loader = settings.nTableWrapper.parentNode.querySelector(".c-tableLoader");

				if (loader) {
					loader.classList.add("c-tableLoader--hidden");
				}

				new Sushi.Plugins.FadeScrollable(settings.nTableWrapper, { bare: true });
			},
		};

		var maxOutterContainerWidth;

		dataTableOptions.preDrawCallback = function (settings) {
			var parentTable = settings.nTableWrapper.closest(".dataTables_scroll");

			if (parentTable) {
				var parentHead = parentTable.querySelector(".dataTables_scrollHeadInner table");

				maxOutterContainerWidth = parentHead.clientWidth;
			}
		};

		dataTableOptions.drawCallback = function (settings) {
			var outterContainer = settings.nTableWrapper.closest(".c-table__slider");

			if (outterContainer) {
				outterContainer.style.maxWidth = maxOutterContainerWidth + "px";

				if (dataTable) {
					dataTable.columns.adjust();
				}
			}
		};

		dataTable = $(tableElement).DataTable(dataTableOptions);
		dataTable.table().body().classList.add("c-table__body");

		window.addEventListener("resize", function () {
			dataTable.draw();
		});

		return dataTable;
	};

})(Sushi || (Sushi = {}), CGS || (CGS = {}), Icons || (Icons = {}));
